import { ViewArticleItem } from "./ViewArticleItem";
export class ViewSetArticleItem extends ViewArticleItem {
    get isGroup() {
        return (true);
    }
    get isOfmlArticle() {
        return (false);
    }
    //// protected /////////////////////////////////////////////////////////////////////////////
    generateImageUrl() {
        this.mImageUrl = "";
        return Promise.resolve();
    }
}
